<div style="display: flex; flex-direction: column; margin-top: 5em;">
    <a href="https://erosmontin.s3.us-east-1.amazonaws.com/CV.pdf" download="Eros_Montin_CV.pdf" class="cv-button" target="_blank">
        Download Eros's CV
    </a>
    
    <div style="display: flex; flex-direction: column; text-align: center;">
        <div class="avatar-background">
            <img src="assets/me.png" alt="Avatar" style="width: 233px; border-radius: 50%; display: block; margin-left: auto; margin-right: auto; max-width: 25%;">
              
        </div>
        <h1 style="margin-top: 1em;">Dr. Eros Montin, Ph.D.</h1>
        
        <div style="display: flex; flex-wrap: wrap; justify-content: center;">
            <h3>
                <a href="https://mail.google.com/mail/?view=cm&fs=1&to=eros.montin@gmail.com&su=Hey Eros!&body=Let's make great science projects together!" target="_blank" title="Email  Eros Montin">
                    <fa-icon [icon]="at" class="btnInfo"></fa-icon>
                </a>
            </h3>
            <h3>
                <a href="https://cai2r.net/about/team/#eros-montin" target="_blank" title="Visit Eros Montin's Profile on CAI2R">
                    <fa-icon [icon]="ad" class="btnInfo"></fa-icon>
                </a>
            </h3>
            <!-- <h3>
                <a href="https://www.linkedin.com/in/eros-montin-46645aab" target="_blank" title="Connect with Eros Montin on LinkedIn">
                    <fa-icon [icon]="lin" class="btnInfo"></fa-icon>
                </a>
            </h3> -->
            <h3>
                <a href="https://github.com/erosmontin" target="_blank" title="View Eros Montin's GitHub Profile">
                    <fa-icon [icon]="gi" class="btnInfo"></fa-icon>
                </a>
            </h3>
            <h3>
                <a href="https://www.instagram.com/erosnitnom" target="_blank" title="Follow Eros Montin on Instagram">
                    <fa-icon [icon]="in" class="btnInfo"></fa-icon>
                </a>
            </h3>
            <h3>
            <a href="https://orcid.org/0000-0002-1773-0064" target="_blank">
                <fa-icon [icon]="['fab', 'orcid']" class="btnInfo"></fa-icon>
            </a>

            </h3>

            <!-- <h3>
                <a href="https://www.researchgate.net/profile/Eros-Montin" target="_blank" title="View Eros Montin's ResearchGate Profile">
                    <fa-icon [icon]="rg" class="btnInfo"></fa-icon>
                </a>
            </h3> -->
            <!-- <h3>
                <a href="https://orcid.org/0000-0002-1773-0064" target="_blank" title="View Eros Montin's ORCID Profile">
                    <fa-icon [icon]="or" class="btnInfo"></fa-icon>
                </a> 
            </h3> -->
        </div>
        
        <div style="display: flex; justify-content: center; margin-top: 1em;">
            <div class="badge-base LI-profile-badge" data-locale="en_US" data-size="large" data-theme="light" data-type="HORIZONTAL" data-vanity="eros-montin-46645aab" data-version="v1">
                <a class="badge-base__link LI-simple-link" href="https://www.linkedin.com/in/eros-montin-46645aab?trk=profile-badge"></a>
            </div>
        </div>

    </div>


    <app-people-main></app-people-main>
    <app-publication-entry></app-publication-entry>
    
</div>